import React from 'react';
import './IconScroll.css';
import { images } from '../../constants';

const IconScroll = () => {
    return (
        <div className="partner-container">
            Saker du lär dig i vår kurs: 
            <div className="tscroll">
                <img src={images.o1Logo} alt="o1 logo" title="o1 logo" className="icon-scroll-image"/>
                <img src={images.o4} alt="4o logo" title="4o logo" className="icon-scroll-image"/>
                <img src={images.chatgpt} alt="ChatGPT logo" title="ChatGPT logo" className="icon-scroll-image"/>
                <img src={images.gptForWork} alt="GPT for Work logo" title="GPT for Work logo" className="icon-scroll-image"/>
                <img src={images.dalle} alt="DALL-E logo" title="DALL-E logo" className="icon-scroll-image"/>
            </div>
        </div>
    );
};

export default IconScroll;